export default __webpack_public_path__ + "static/media/redemption-icon.e5265768.svg";